<template>
    <!-- The design's home: a grey cookie band, the panel family, one call to action. -->
    <div>
        <div v-if="showCookieBand" class="home-cookie">
            <p class="home-cookie-text" v-html="$lang.Menus.CookieText"></p>
            <b-button class="home-cookie-ok" type="is-primary" @click="closeCookieText()">{{ $lang.Menus.Okay }}</b-button>
        </div>

        <div class="home-body">
            <img class="home-image" src="/img/MainMenu.webp" alt="EAE pano ailesi" />
            <b-button class="home-cta" type="is-primary" @click="openNewProject()">
                {{ $lang.NewProject.NewProject }}
            </b-button>
        </div>
    </div>
</template>

<script>
    import router from '@/router';
    // import api from '@/api';

    const COOKIE_CONSENT = 'paneltemp_cookie_consent';
    const COOKIE_CONSENT_DAYS = 30;

    const hasCookieConsent = () => document.cookie.split(';').some((c) => c.trim().startsWith(COOKIE_CONSENT + '='));

    export default {
        name: 'MainMenu',
        data() {
            return {
                isActive: true,
                isAccepted: false,
                hasError_isAccepted: false,
                showCookieBand: !hasCookieConsent()
            }
        },
        mounted() {
            this.$store.state.projectId = '';

            this.$store.state.isFooterFixed = true;

            this.openCookieLink();
        },
        destroyed() {
            this.$store.state.isFooterFixed = false;
        },
        methods: {
            openNewProject() {
                router.push('/newProject');
                /* this.controlInputs();
                if (this.isAccepted) {
                    var uuid = this.generateUUID();

                    this.resetPreviousDatas();
                    this.$store.state.prevProjectId = -1;
                    this.$store.state.isPrevProject = false;
                    this.$store.state.projectId = uuid + "_Temp";
                    this.$store.state.calcIndex = 1;
                    this.$store.state.circIndex = 1;

                    const currDate = new Date();
                    const log = {
                        MemberId: this.$store.state.memberId,
                        ProjectId: this.$store.state.projectId,
                        IsAccepted: 1,
                        AcceptDate: currDate
                    };
                    api.panels.addNewProjectLog(log).then((res) => {
                        if (res.isError) {
                            console.log("error ");
                        } else {
                            router.push('/projectInfos');
                        }
                    });
                } */
            },
            continueProject() {
                this.controlInputs();
                if (this.isAccepted) {
                    router.push('/projectInfos');
                }
            },

            generateUUID() {
                var d = new Date().getTime(); // Timestamp
                var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now() * 1000)) || 0; // Time in microseconds since page-load or 0 if unsupported
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16; // random number between 0 and 16
                    if (d > 0) { // Use timestamp until depleted
                        r = (d + r) % 16 | 0;
                        d = Math.floor(d / 16);
                    } else { // Use microseconds since page-load if supported
                        r = (d2 + r) % 16 | 0;
                        d2 = Math.floor(d2 / 16);
                    }
                    return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
                });
            },

            resetPreviousDatas() {
                this.$store.activeStep = 0;
                this.$store.canPanelInfosOpen = false;
                this.$store.canEnvConditionsOpen = false;
                this.$store.canCalculationOpen = false;
                this.$store.canResultOpen = false;
                this.$store.canReportPageOpen = false;
                this.$store.canFanCalcOpen = false;

                var payload = { langCode: "", projectName: "", panelName: "", panelNo: "", panelManifacturer: "", lastUserName: "", ratedCurrentIndex: -1, panelRatedCurrent: "", totalEyesNumber: 0, eyesNumber: 0 };
                this.$store.commit('setProjectInfos', payload);

                var payload2 = { panelType: "", panelTypeIndex: 0, panelDimension: "", panelIP: "", selectedIP_Id: 0, Sair: "", surfaceExplanation: "", virtualSurface: "", virtualSurfaceIndex: 0, virtualSurfaceOption: 0, seperationNumber: 0, ae_value: 0, ae_valueList: [] };
                this.$store.commit('setPanelInfos', payload2);

                var payload3 = { envTemperature: 0, maxTemperature: 0, humidity: "", altitude: 0 };
                this.$store.commit('setEnvConditionDatas', payload3);

                var payload4 = { totalLostPower_1: 0 };
                this.$store.commit('setCalculationDatas', payload4);

                var payload5 = { inPanelTemperature: 0, envMeasureTemperature: 0, totalLostPower_2: 0 };
                this.$store.commit('setCalculationDatas_2', payload5);

                var payload6 = { InputCircuitDef: "", P_InputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_InputCircuits', payload6);

                var payload7 = { OutputCircuitDef: "", P_OutputCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_OutputCircuits', payload7);

                var payload8 = { ManuelCircuitDef: "", P_ManuelCircuit: 0, totalLostPower_3: 0 };
                this.$store.commit('set_Datas_ManuelCircuits', payload8);

                var payload9 = { P_890: 0, P_Total: 0, result_630A: 0 };
                this.$store.commit('setResultInfos_630A', payload9);

                var payload10 = { value_k: 0, n_value: 0, value_d: 0, value_x: 0, deltaT_0_5: 0, Ab_val: 0, height_val: 0, value_f: 0, value_g: 0, value_c: 0, deltaT_0_75: 0, deltaT_1: 0, result_1600A: 0 };
                this.$store.commit('setResultInfos_1600A', payload10);
            },

            controlInputs() {
                if (this.isAccepted == false) {
                    this.hasError_isAccepted = true;
                } else {
                    this.hasError_isAccepted = false;
                }
            },

            openCookieLink() {
                var cookieLink = document.querySelector('.dataPrivacy');
                if (cookieLink != null) {
                    cookieLink.addEventListener('click', function () {
                        window.open(
                            'https://eaeelektroteknik.com/kisisel-verilerin-korunmasi-islenmesi-ve-gizlilik-politikasi/',
                            '_blank' // <- This is what makes it open in a new window.
                        );
                    });
                }
            },

            // "Tamam" is remembered for 30 days in a cookie. It set a store flag without a
            // mutation, which was never saved: the band came back on every reload and tab.
            closeCookieText() {
                const secure = window.location.protocol === 'https:' ? '; Secure' : '';
                document.cookie = COOKIE_CONSENT + '=1; Max-Age=' + COOKIE_CONSENT_DAYS * 24 * 60 * 60 + '; Path=/; SameSite=Lax' + secure;
                this.showCookieBand = false;
            }
        }
    };
</script>

<style lang="scss">
    /* NewProject.vue and Results.vue use .center2 too - it lives here, keep it. */
    .center2 {
        margin: auto;
        width: 50%;
        text-align: center;
    }

    .dataPrivacy {
        cursor: pointer;
    }

    .home-cookie {
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 14px calc(26px + var(--page-bleed)); /* centred above 1440px, scss/_page-width.scss */
        background: #efefef;
        border-bottom: 1px solid #e3e3e3;
    }

    .home-cookie-text {
        flex: 1;
        min-width: 0;
        margin: 0;
        font-size: 13px;
        font-weight: 300;
        line-height: 1.6;
        color: #575757;

        /* The link comes from the dictionary as <u><b>...</b></u>. */
        .dataPrivacy { color: #0060a0; font-weight: 600; }
        .dataPrivacy u { text-decoration: none; }
        .dataPrivacy b { font-weight: 600; }
    }

    .button.home-cookie-ok {
        flex: none;
        height: 36px;
        padding: 0 18px;
        font-size: 13px;
    }

    .home-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 32px;
        padding: 48px 40px 56px;
    }

    .home-image {
        display: block;
        width: 100%;
        max-width: 760px;
        height: auto;
    }

    .button.home-cta {
        height: 50px;
        padding: 0 30px;
        font-size: 16px;
    }

    @media screen and (max-width: 768px) {
        .home-cookie {
            flex-direction: column;
            align-items: flex-start;
            padding: 16px 18px;
        }

        .home-body {
            gap: 24px;
            padding: 28px 18px 40px;
        }
    }
</style>
